/**
 * The tabs of a collection's page. Each value is the URL segment after
 * `/collections/:collectionId` that opens the tab: `CollectionsRoutes`
 * registers the tab's route at that segment, `Goto.createCollectionRoute`
 * links to it, and the tab strip reads it back to mark the active tab.
 */
export enum CollectionTab {
  Items = "items",
  Details = "details",
  Activity = "activity",
  Permissions = "permissions",
}
